import React, { useState, useMemo } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  FormGroup,
  InputGroup,
  FormControl,
} from "react-bootstrap";
import { injectIntl } from "react-intl";
import { useQuery, useMutation, queryCache } from "react-query";
import Alert from "react-s-alert";

import PageLoading from "../../../components/Loading";
import SpeakerRow from "../../../components/speakers/row";
import ArchiveHeader from "../../../components/ArchiveHeader";

import CreateItemForm from '../../../components/CreateItemForm';
import Table from '../../../components/TableNew';
import SortButton from "../../../components/SortButton";
import { getSpeakers, deleteSpeaker } from "./xhr";

import { ExportSpeakers, ImportSpeakers } from './import-export'

const Speakers = ({ intl, locale, setLocale }) => {
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState("firstName");
  const [order, setOrder] = useState("asc");
  const [speakerName, setSpeakerName] = useState('');
  const [showSort, setShowSort] = useState(false);

  const { isLoading, isError, error, data: speakers } = useQuery('speakers', getSpeakers, {
    onError: (err) => {
      Alert.error(intl.formatMessage({ id: err.response.data.message }))
    }
  });

  const [deleteSpeakerMutation] = useMutation(deleteSpeaker, {
    onSuccess: (deletedSpeaker) => {
      if(queryCache.getQueryData('speakers')) {
        queryCache.setQueryData('speakers', speakers => speakers
          .filter(speaker => speaker._id !== deletedSpeaker._id)
        )
      }
      Alert.success(intl.formatMessage({ id: 'speaker.delete-success' }));
    },
    onError: (err) => {
      Alert.error(intl.formatMessage({ id: err.response.data.message }))
    }
  })

  const columns = useMemo(
    () => [
      {
        Header: "Speakers",
        accessor: ({ _id, ...row }) => {
          return Object.values(row).join("|");
        },
        Cell: ({ cell: { value }, row: { original } }) => (
          <SpeakerRow
            key={original._id}
            title={original.title}
            name={`${original.firstName} ${original.lastName}`}
            email={original.email}
            image={original.picture}
            id={original._id}
            deleteFn={(_id) => {
              deleteSpeakerMutation({ _id })
            }}
          />
        ),
      },
    ],
    [deleteSpeakerMutation]
  );

  const sortOptions = useMemo(() => [
    {
      label: 'input.firstname',
      value: 'firstName',
      sort: (a, b) => a.firstName.localeCompare(b.firstName),
    },
    {
      label: 'input.lastname',
      value: 'lastName',
      sort: (a, b) => a.lastName.localeCompare(b.lastName),
    },
    {
      label: 'input.email',
      value: 'email',
      sort: (a, b) => (a.email || `zzzz${a.firstName}`).localeCompare(b.email || `zzzz${b.firstName}`)
    },
  ], []);

  if (isLoading) {
    return <PageLoading />;
  }

  if (isError) {
    return <span>Error: {error.message}</span>
  }

  return (
    <React.Fragment>
      <ArchiveHeader locale={locale} setLocale={setLocale} intl={intl} title="heading.speakers" />
      <div className="pad-2rem">
        <Container fluid>
          <Row className="align-items-center m-b-20">
            <Col xl={5}>
              <CreateItemForm
                heading="create.speaker.form"
                setFunc={setSpeakerName}
                placeholder={intl.formatMessage({ id: 'input.speaker.name' })}
                link={`/speakers/add/${speakerName}`}
              />
            </Col>
            <Col xl={7}>
              <Row className="align-items-center">
                <Col md={5}>
                  <div className="text-right search-container">
                    <FormGroup>
                      <InputGroup onChange={(e) => setSearch(e.target.value)}>
                        <FormControl type="text" />
                        <InputGroup.Append>
                          <Button>
                            <img src="/icons/search.png" alt="plus" />
                          </Button>
                        </InputGroup.Append>
                      </InputGroup>
                    </FormGroup>
                  </div>
                </Col>
                <Col md={5}>
                  <div className="dropdown-filters">
                    {/* <FormGroup controlId="sort" className="sort-filter">
                      <img className="sort-icon" alt="" src="/icons/list.png" />
                      <FormControl onChange={(e) => setSort(e.target.value)} as="select">
                      {
                          sortOptions.map((o, i) => (
                            <option key={i} value={o.value} selected={o.value === sort}>{intl.formatMessage({ id: o.label })}</option>
                          ))
                        }
                      </FormControl>
                    </FormGroup> */}
                    <SortButton
                      showSort={showSort}
                      setShowSort={setShowSort}
                      sortOptions={sortOptions}
                      intl={intl}
                      setSort={setSort}
                      sort={sort}
                      order={order}
                      setOrder={setOrder}
                    />
                    {/* <Button className="sort-btn" onClick={() => setOrder(order === "asc" ? "desc" : "asc")}>
                      {order === "asc" ? <i className="fas fa-sort-amount-down-alt"></i> : <i className="fas fa-sort-amount-down"></i>}
                    </Button> */}
                  </div>
                </Col>
                <Col md={1}>
                  <ExportSpeakers data={speakers} />
                </Col>
                <Col md={1}>
                  <ImportSpeakers />
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col>
              {/* <pre>{JSON.stringify(speakers, null, 2)}</pre> */}
              <Table
                columns={columns}
                data={speakers
                  .sort(sortOptions.find((so) => so.value === sort).sort)
                  .map((d, i) => ({
                    ...d, i: i
                    * (order === "asc" ? 1 : -1)
                  }))
                  .sort((a, b) => a.i - b.i)}
                search={search}
                intl={intl}
              />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

// const mapStateToProps = (state) => ({
//   // speakers: state.speaker.allSpeakers,
//   userProfile: state.user.profile,
// });

// export default connect(mapStateToProps)(injectIntl(Speakers));

export default injectIntl(Speakers);
